<template>
  <div class="payable-now-and-balance">
    <section class="cost-section now">
      <table class="totals">
        <tbody>
          <tr>
            <td>
              <translate class="amount" tag="h4">Payable now</translate>
            </td>
            <td class="amount">
              <pu-price :price="deposit" :display-original-price="true" />
            </td>
          </tr>
          <tr class="info">
            <td colspan="2">
              <translate tag="p" :tt="{ depositPercent }">
                This is a {depositPercent, number, percent} non-refundable
                deposit.
              </translate>
            </td>
          </tr>
        </tbody>
      </table>
    </section>

    <section class="cost-section later">
      <table class="totals">
        <tbody>
          <tr class="balance">
            <td>
              <translate class="amount" tag="h4">Balance</translate>
            </td>
            <td class="amount">
              <pu-price :price="remainder" :display-original-price="true" />
            </td>
          </tr>
          <tr class="info">
            <translate
              tag="td"
              colspan="2"
              :tt="{ campsiteName, balanceDueDate }"
            >
              {campsiteName} will debit your card on {balanceDueDate, puDate,
              full}.
            </translate>
          </tr>
        </tbody>
      </table>
    </section>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { SimpleMoney } from '~/utility/money'

@Component
class StripePaymentDeferred extends Vue {
  @Prop()
  deposit: SimpleMoney

  @Prop()
  remainder: SimpleMoney

  @Prop()
  balanceDueDate: string

  @Prop()
  campsiteName: string

  @Prop()
  depositPercent: number
}

export default toNative(StripePaymentDeferred)
</script>
